import React, { Component } from 'react';
import './Macro.css';

import Micro from '../Micro/Micro';

import { connect } from 'react-redux';
import { placeSquare } from 'Game/State';

class Macro extends Component {
  constructor(props) {
    super(props);

    this.state = { board: new Array(3).fill(null).map(() => { return new Array(3).fill('') }) }
  }

  render() {
    let elements = [];

    // Process one row at a time
    for (var y = 0; y < 3; y++) {
      let row = [];
      for (var x = 0; x < 3; x++) {
        row.push((<Micro key={ x }
          board={ this.props.board[x][y].board }
          winner={ this.props.board[x][y].winner }
          active={ !this.props.active || (this.props.active[0] === x && this.props.active[1] === y) }
          player={ this.props.player }
          onClick={ this.onClick.bind(this, x, y) } />))
      }

      elements.push(row);
    }

    return (
      <div className={`Macro-Board ${ this.props.winner }`} disabled={ this.props.waitingOnRemote }>
        { elements.map((row, y) => { return (<div key={ y }>{ row }</div>) }) }
      </div>
    );
  }

  onClick(xl, yl, xs, ys) {
    this.props.dispatch(placeSquare(xl, yl, xs, ys));

    this.props.onMove([xl, yl], [xs, ys]);
  }
}

const mapStateToProps = state => {
  return {
    board: state.board,
    active: state.active,
    winner: state.winner,
    player: state.player,
    waitingOnRemote: state.waitingOnRemote
  }
}

export default connect(mapStateToProps)(Macro);



// WEBPACK FOOTER //
// ./src/Game/Macro/Macro.js